var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LmFormBuilder',{attrs:{"endpointUriwhereGetComponents":("formbuilder/" + (_vm.$route.params.idFormBuilder)),"endpointUriWhereGetValuesToLoadInEditMode":_vm.fullEndpointUriToGetFormValues}})}
var staticRenderFns = []

export { render, staticRenderFns }